import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Modal} from 'react-bootstrap';
import {actions} from 'react-redux-form'
import {initPersonalRewardsForm, savePersonalRewards} from '../../../actions/staff'
import UserDetailsForm from './ppc-user-form';
import {getMyProfile} from '../../../actions/user';
import * as moment from 'moment'

import './styles.css'

class YourPersonalRewards extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {

    const profile = this.props.profile;
    const data = {
      title: profile.title || '',
      first_name: profile['first-name'] || '',
      last_name: profile['last-name'] || '',
      date_of_birth: moment(profile['date-of-birth'], "YYYY-MM-DD").format("DD/MM/YYYY") || '',
      address_1: profile["personal-address-1"] || '',
      address_2: profile["personal-address-2"] || '',
      town: profile["personal-address-3"] || '',
      county: profile["personal-address-4"] || '',
      eircode: profile["personal-eircode"] || '',
      store_name: '',
      email: profile.email || '',
      mobile: profile.mobile || '',
      accept_terms: false
    };
    this.props.dispatch(actions.load('deep.personal_rewards', data));
  }

  componentDidMount() {
    const { popupActive } = this.props;
    popupActive(true);
  }

  componentWillUnmount() {
    const { popupActive, dispatch } = this.props;
    popupActive(false);
    dispatch(actions.reset('deep.personal_rewards'));
  }

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.personal_rewards', savePersonalRewards(payLoad)))
        .then(() => this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE')));
  };

  render() {

    return (
      <Modal
        show={true}
        className="personal-rewards-popup"
        container={this}
        aria-labelledby="contained-modal-title">
        <Modal.Header>
          <Modal.Title>YOUR PERSONAL REWARDS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We have updated you reward preferences and a proportion of the reward points you earn will now be allocated
            to your
            personal rewards pot.
          </p>
          <p>
            In order to receive your personal rewards, you will need to opt in to the ignite Prepaid Mastercard by
            completing the form
            below. Please ensure that all the details you provide are accurate to avoid any problems isuing your prepaid
            card.
          </p>
          <UserDetailsForm onSubmit={this.onSubmit}/>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.viewConfig.profile.attributes
  };
};

export default connect(mapStateToProps)(YourPersonalRewards);


// WEBPACK FOOTER //
// ./src/components/home/personal-rewards/index.jsx